/**
 * Search Slice
 * Manages search state and results
 */

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../services/api';

const initialState = {
  query: '',
  searchType: 'assets', // 'assets' | 'projects'
  results: [],
  loading: false,
  error: null,
  searchByProjectId: false,
};

// Async thunks
export const performSearch = createAsyncThunk(
  'search/perform',
  async ({ query, type, customerId }, { rejectWithValue }) => {
    try {
      const result = await api.search(query, type, customerId);
      return {
        items: result.items || [],
        type,
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    initSearch: () => initialState,
    
    setQuery: (state, action) => {
      state.query = action.payload;
    },
    
    setSearchType: (state, action) => {
      state.searchType = action.payload;
    },
    
    setSearchByProjectId: (state, action) => {
      state.searchByProjectId = action.payload;
    },
    
    clearResults: (state) => {
      state.results = [];
      state.error = null;
    },
    
    clearSearch: (state) => {
      state.query = '';
      state.results = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(performSearch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(performSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.results = action.payload.items;
        state.searchType = action.payload.type;
      })
      .addCase(performSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  initSearch,
  setQuery,
  setSearchType,
  setSearchByProjectId,
  clearResults,
  clearSearch,
} = searchSlice.actions;

export default searchSlice.reducer;
